/**
 * Identity
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ObserverPermissionResponse } from './observer-permission-response';


export interface ObserverByKeyResponse { 
    description?: string | null;
    observerPermissions: Array<ObserverPermissionResponse>;
}

